import React from 'react';
import PropTypes from 'prop-types';

import './skeleton-element.scss';

function SkeletonElement(props) {
  const { className } = props;

  return <div className={className} styleName="default" />;
}

SkeletonElement.propTypes = {
  className: PropTypes.string
};

export default SkeletonElement;
